import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import formatDate from 'utils/formatDate'

const ArticlePreview = (props) => {
  const { entry, widgetFor } = props
  const title = entry.getIn(['data', 'title'])
  const originalAuthor = entry.getIn(['data', 'originalAuthor'])
  const displayAuthor = entry.getIn(['data', 'displayAuthor'])
  const date = entry.getIn(['data', 'date'])
  const thumbnail = entry.getIn(['data', 'thumbnail'])
  const quote = entry.getIn(['data', 'quote'])
  const content = widgetFor('body')
  const imgPlaceholder =
    'https://s3-us-west-1.amazonaws.com/healthfulinspired/app/img-placeholder.png'

  let author = null
  if (displayAuthor && originalAuthor) {
    if (/(christopher t|christopher roberts)/i.test(originalAuthor)) {
      author = (
        <Typography style={{ textAlign: 'center' }}>
          Author:{' '}
          <a
            style={{
              color: '#0070c2',
              textDecoration: 'none',
            }}
            className="author"
            href="https://healthfulinspired.com/authors/christopher-roberts"
          >
            {originalAuthor}
          </a>
        </Typography>
      )
    } else {
      author = (
        <Typography style={{ color: '#666', textAlign: 'center' }}>
          Author: {originalAuthor}
        </Typography>
      )
    }
  }

  const currentQuote = {
    author: quote.author,
    quote: quote.quote,
    tags: quote.tags,
  }

  console.log(currentQuote)

  return (
    <div
      style={{
        fontFamily: 'Roboto',
        padding: '0 10px',
        color: '#333',
        lineHeight: 1.9,
        fontSize: '1.05em',
        fontWeight: 400,
      }}
      className="container"
    >
      <div
        style={{
          padding: '0 10px',
          lineHeight: 1.9,
          fontSize: '1.05em',
          fontWeight: 400,
          fontFamily: 'Roboto',
        }}
      >
        <Typography variant="display1" align="center" className="title">
          {title}
        </Typography>
        {author}
        <Typography
          style={{
            color: '#999',
            fontStyle: 'italic',
            paddingBottom: 10,
            textAlign: 'center',
            fontSize: '0.85em',
          }}
          className="formatDate"
        >
          {formatDate(date)} {'\u2022'} 5 min read
        </Typography>
        <img
          style={{ height: 430, width: '100%', objectFit: 'cover' }}
          className="thumbnail"
          src={thumbnail || imgPlaceholder}
          alt={title}
          title={title}
        />
        <div className="markdown">{content}</div>
      </div>
      <style>{`
        .markdown img {
          width: 100%;
          height: 350px;
          object-fit: cover;
          border: 1px solid #e5ebed;
        }
        .markdown {
          color: #333;
        }
        table {
          border: 1px solid #58b1bb;
        }
        table th {
          background: #58b1bb;
          color: #fff;
          padding: 10px;
        }
        table td {
          border: 1px solid #58b1bb;
        }
        h1, h2, h3, h4, h5, h6 {
          line-height: 1em;
        }
        h1 {
          padding: 15px 0;
        }
        .title {
          text-align: center;
          font-weight: 600;
          padding-top: 10px;
          color: #285978;
          text-transform: none;
        }
        .author:hover {
          color: #7c04da !important;
        }
        @media (max-width: 600px) {
          .container {
            font-size: 0.9em;
          }
          div.markdown h1, h2, h3 {
            font-size: 1.4em;
          }
          div.markdown img {
            height: 100%;
          }
          .title {
            font-size: 1.4em;
          }
          .originalAuthor {
            font-size: 0.9em;
          }
          .formatDate {
            font-size: 0.9em;
          }
        }
        @media (max-width: 960px) {
          .thumbnail {
            height: 100%;
          }
        }
      `}</style>
    </div>
  )
}

ArticlePreview.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default ArticlePreview



// WEBPACK FOOTER //
// ./src/cms/previews/Article.js